/** Reverse proxy PostHog (même projet que le pro — évite les ad blockers). */
export const POSTHOG_PROXY_API_HOST = 'https://t.rintintin-pro.com';

/** Ingestion directe PostHog EU (dev local). */
export const POSTHOG_DIRECT_API_HOST = 'https://eu.i.posthog.com';

export const POSTHOG_UI_HOST = 'https://eu.posthog.com';

export function resolvePostHogApiHost(): string {
  const fromEnv = process.env.REACT_APP_POSTHOG_HOST?.trim();
  if (fromEnv) return fromEnv;
  return process.env.NODE_ENV === 'production' ? POSTHOG_PROXY_API_HOST : POSTHOG_DIRECT_API_HOST;
}

export function resolvePostHogUiHost(): string {
  return process.env.REACT_APP_POSTHOG_UI_HOST?.trim() || POSTHOG_UI_HOST;
}
